import { HTMLAttributes } from 'react';
import styles from './Legend.module.scss';
import { joinClassNames } from '../../../../utils';

type LegendProps = HTMLAttributes<HTMLLegendElement>;

export const Legend = ({ children, className, ...props }: LegendProps) => {
  const classNames = joinClassNames(styles.legend, className);
  return (
    <legend className={classNames} {...props}>
      {children}
    </legend>
  );
};
